import styled from 'styled-components';

export const Wrapper = styled.div`
  .search-bar {
    display: flex;

    .search-input {
      margin-bottom: 20px;
    }

    .search-functions {
      width: fit-content;
      min-width: fit-content;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    // Overrides
    .RUIInput-input,
    .RUIInput-input-0-2-1144:focus:not(:disabled),
    .RUIInput-input-0-2-1144:active:not(:disabled) {
      color: white;
      border-bottom-color: white;
      min-width: 100%;
    }

    .RUIInput-base {
      width: 90%;
    }
  }

  .highlight {
    background-color: #ffff006e;
  }
`;
